import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import Bullet from "@material-ui/icons/DragIndicator";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";

import servicesStyle from "assets/jss/material-kit-pro-react/views/aboutUsSections/servicesStyle.jsx";

function SectionServices(props) {
  const { classes } = props;
  return (
    <div className={classes.services}>
      <GridContainer>
        <GridItem
          md={8}
          sm={8}
          className={classNames(
            classes.mlAuto,
            classes.mrAuto,
            classes.textCenter
          )}
        >
          <h2 className={classes.title}>What we offer</h2>
          <h5 className={classes.description}>
            Kinos’s partnership culture, our commitment to excellence and uncompromising integrity makes us an excellent choice for investors with a long-term vision.
          </h5>

          <h5 className={classes.description}>Our client´s interest first is the core of our asset management philosophy.
We also custom tailor your investment strategies to clients’ specific needs.
</h5>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem md={6} sm={6}>
          <InfoArea
            title="ADVISORY & TRANSACTION SERVICES"
            description={
              <span>
                <p>
                  Helping you realize desired results with a deliberate, forward-thinking approach to deal planning, execution and integration.
                  There is more pressure than ever before to ensure deals deliver lasting results for stakeholders. At Kinos, we see transactions through an investor’s lens and are focused on helping clients identify, evaluate and successfully implement their growth strategies in today’s complex business landscape.

                </p>
              </span>
            }
            icon={Bullet}
            iconColor="rose"
          />
        </GridItem>
        <GridItem md={6} sm={6}>
          <InfoArea
            title="PROPERTY MANAGEMENT"
            description={
              <span>
                <p>
                  At Kinos, we help owners improve the returns generated by their properties. How? By defining the best strategy and repositioning the asset in order to attract the best tenants and buyers.
                  We accompany you every step of the way from analysis buy until disinvestment end.

                </p>
              </span>
            }
            icon={Bullet}
            iconColor="rose"
          />
        </GridItem>
        <GridItem md={6} sm={6}>
          <InfoArea
            title="RELATIONSHIPS"
            description={
              <span>
                <p>
                  We have a strong local presence, international relations and business network with collaboration platform Torus. This is essential. Relationships with local business leaders, bankers, accountants, financial advisors, and those involved in supply chain management is important sources of deal flow. Networks, relationships, and partnerships with others professionals  are all essential for developing a robust investment pipeline.

                </p>
              </span>
            }
            icon={Bullet}
            iconColor="rose"
          />
        </GridItem>
        <GridItem md={6} sm={6}>
          <InfoArea
            title="PROPERTY SALES"
            description={
              <span>
                <p>
                  In order to source deals, assets must effectively market themselves and present their unique value proposition for potential investors and have other thoughtful strategy for identifying future investments. Equally important is a well-established process for evaluating potential investments thoroughly and efficiently.

                </p>
              </span>
            }
            icon={Bullet}
            iconColor="rose"
          />
        </GridItem>

        <GridItem md={6} sm={6}>
          <InfoArea
            title="Investment strategies"
            description={
              <span>
                <p>
                  <ul>
                    <li>Management of JV or Development Process</li>
                    <li>Financial Operating Modelling</li>
                    <li>Budgeting and control</li>
                    <li>Legal Structuring and Specifications</li>
                    <li>Tech-Enabled Interaction</li>
                    <li>Financial Reporting</li>
                    <li>Operation Reporting</li>
                    <li>Marketing Strategy</li>
                    <li>Sales Strategy</li>
                    <li>Life Cycle Cost Analysis</li>
                    <li>Asset Positioning</li>
                    <li>Exit Strategy</li>
                  </ul>
                </p>

              </span>
            }
            icon={Bullet}
            iconColor="rose"
          />
        </GridItem>
        <GridItem md={6} sm={6}>
          <InfoArea
            title="Investment channels"
            description={
              <span>
                <p>
                  <ul>
                    <h6>Direct Investments</h6>
                    <li>In real estate assets </li>
                    <li>In projects</li> 
                    <h6>Through Intermediaries</h6>
                    <li>InvestmentManagers </li>
                    <li>Private equity funds </li>
                    <li>Infrastructure funds</li> 
                    <li>Socimis</li> 
                    <li>Reits</li> 
                    <h6>Other pooled investment vehicles...</h6>
                  </ul>
                </p>

              </span>
            }
            icon={Bullet}
            iconColor="rose"
          />
        </GridItem>

      </GridContainer>
    </div>
  );
}


export default withStyles(servicesStyle)(SectionServices);
